// extracted by mini-css-extract-plugin
module.exports = {"modal":"ReviewSuccessModal-module__modal___RrXwV"};